import { ReactNode } from 'react';

import classNames from 'classnames';

import { Box, BoxProps, Inline, Text } from '../index';

import {
  dialogStyle,
  dialogHeaderStyle,
  dialogFooter,
  dialogBorder,
  dialogBoxShadow,
  roundTopStyle,
  roundBottomStyle,
} from './Dialog.css';
import { DialogCloseButton } from './DialogCloseButton';

interface DialogProps {
  drawBorder?: boolean;
  drawBoxShadow?: boolean;
  roundBottom?: boolean;
  roundTop?: boolean;
  children: ReactNode;
}

export function Dialog({
  drawBorder = true,
  drawBoxShadow = true,
  roundTop = true,
  roundBottom = true,
  children,
}: DialogProps): JSX.Element {
  return (
    <Box
      background="body"
      className={classNames(
        dialogStyle,
        drawBorder ? dialogBorder : '',
        drawBoxShadow ? dialogBoxShadow : '',
        roundTop ? roundTopStyle : '',
        roundBottom ? roundBottomStyle : ''
      )}
    >
      {children}
    </Box>
  );
}

export const DialogHeader = ({
  title,
  leadingIcon,
  onClose,
}: {
  title: string;
  leadingIcon?: ReactNode;
  onClose?: () => void;
}): JSX.Element => {
  return (
    <Box className={dialogHeaderStyle} display="flex" justifyContent="spaceBetween" alignItems="center">
      <Inline alignY="center" gap={leadingIcon ? 'medium' : 'none'}>
        {leadingIcon && leadingIcon}
        <Text size="large" weight="demibold">
          {title}
        </Text>
      </Inline>
      {onClose && <DialogCloseButton onClose={onClose} />}
    </Box>
  );
};

interface DialogContentProps {
  children: ReactNode;
  padding?: BoxProps['padding'];
}

export const DialogContent = ({ children, padding = 'medium' }: DialogContentProps): JSX.Element => {
  return <Box padding={padding}>{children}</Box>;
};

export const DialogFooter = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <Box background="body" className={classNames(dialogFooter, roundBottomStyle)}>
      {children}
    </Box>
  );
};

export const StickyBottom = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <Box style={{ zIndex: 5 }} position="sticky" bottom={0} left={0} right={0}>
      {children}
    </Box>
  );
};
